import { Box, Icon, Typography } from '@mui/material'
import React from 'react'
import SampleDataDrawer from './SampleDataDrawer'

const data = [
  {
    id: 3,
    name: 'Ahmad Hashim bin Abdul Haji',
    email: 'ahmad@adxsample.com',
    rating: 2.6,
    uploadedDate: '26/09/2023',
  },
  {
    id: 1,
    name: 'Amirah Hassan',
    email: 'amirah@adxsample.com',
    rating: 2.6,
    uploadedDate: '26/09/2023',
  },
  {
    id: 2,
    name: 'Farah Liyana Binti Tan',
    email: 'farah@adxsample.com',
    rating: 2.6,
    uploadedDate: '18/08/2023',
  },
]

const SampleDataList = () => {
  return (
    <Box>
      <Typography sx={{ color: 'light-gray-text.main', marginBottom: '16px' }}>
        Sample data (3)
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', paddingBottom: '43px' }}>
        {data.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              gap: '20px',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingX: '16px',
              paddingY: '20px',
              backgroundColor: 'white.main',
              borderTop: index > 0 ? '1px solid #E5E5E5' : 'none',
            }}
          >
            <Box sx={{ width: 1 / 3, display: 'flex', alignItems: 'center', gap: '14px' }}>
              <Box
                sx={{
                  backgroundColor: 'default-background.main',
                  borderRadius: '100%',
                  width: '35px',
                  height: '35px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Icon sx={{ color: 'alternate.main', fontSize: '24px' }}>
                  person_outline_outlined
                </Icon>
              </Box>
              <Box>
                <Typography>{item.name}</Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ color: 'light-gray-text.main', marginTop: '' }}
                >
                  Uploaded on {item.uploadedDate}
                </Typography>
              </Box>
            </Box>
            <Typography sx={{ width: 1 / 3, color: 'light-gray-text.main' }}>
              {item.email}
            </Typography>
            <Box
              sx={{
                width: 1 / 4,
                display: 'flex',
                gap: '20px',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <Icon sx={{ color: '#F3BF3A', fontSize: '16px' }}>stars_rounded</Icon>
                <Typography>{item.rating}</Typography>
              </Box>
              <SampleDataDrawer sampleId={item.id} />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default SampleDataList
